import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
export function AlquilerApps() {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    localidad: '',
    registro: 'Registro profesional',
    modalidad: 'Turno — 12 horas',
    trabaja: 'No, quiero empezar'
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const message = `Hola Flash & Go! Me interesa alquilar un auto para apps. Mis datos:
*Nombre:* ${formData.nombre}
*Teléfono:* ${formData.telefono}
*Localidad:* ${formData.localidad}
*Registro:* ${formData.registro}
*Modalidad:* ${formData.modalidad}
*¿Trabaja en app?:* ${formData.trabaja}`;
    window.open(`https://wa.me/5491168898054?text=${encodeURIComponent(message)}`, '_blank');
  };
  const cards = [{
    badge: '12 HORAS',
    title: 'Turno',
    desc: 'Alquilá el auto por turno de 12 horas. Ideal para arrancar a generar ingresos de forma flexible.'
  }, {
    badge: '24 HORAS',
    title: 'A cargo',
    desc: 'El auto es tuyo las 24 horas. Máxima disponibilidad para maximizar tus ganancias.'
  }, {
    badge: 'MES 12 ES TUYO',
    title: 'Alquiler con opción a compra',
    desc: 'Alquilás, trabajás y al mes número 12 el auto pasa a ser tuyo. La forma más inteligente de tener tu propio auto.'
  }];
  return <section id="alquiler" className="py-32 bg-brand-black relative" data-id="element-6">
      <div className="max-w-7xl mx-auto px-6" data-id="element-7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-8">
          <h2 className="font-heading text-5xl md:text-6xl text-brand-white mb-4" data-id="element-9">
            Trabajá en apps con{' '}
            <span className="text-brand-gold" data-id="element-10">nuestros autos</span>
          </h2>
          <p className="text-xl text-brand-gold" data-id="element-11">
            Uber · Cabify · inDriver · Beat y más
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-12">
          {cards.map((card, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#111] border border-brand-gold/30 p-8 rounded-xl relative" data-id="element-13">
              <div className="absolute -top-4 left-8 bg-brand-gold text-brand-black text-xs font-bold px-3 py-1 rounded-full" data-id="element-14">
                {card.badge}
              </div>
              <h3 className="font-heading text-3xl text-brand-white mt-4 mb-4" data-id="element-15">
                {card.title}
              </h3>
              <p className="text-brand-white/70 leading-relaxed" data-id="element-16">{card.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-[#111] border border-brand-gold/30 p-8 rounded-xl relative overflow-hidden" data-id="element-17">
          <div className="absolute top-0 left-0 w-full h-1 bg-brand-gold" data-id="element-18"></div>
          <h3 className="font-heading text-3xl text-brand-gold mb-6 text-center" data-id="element-19">
            Quiero alquilar un auto
          </h3>

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-20">
            <div className="grid md:grid-cols-2 gap-4" data-id="element-21">
              <div data-id="element-22">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-23">
                  Nombre completo
                </label>
                <input required type="text" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                nombre: e.target.value
              })} data-id="element-24" />
              </div>
              <div data-id="element-25">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-26">
                  Teléfono
                </label>
                <input required type="tel" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                telefono: e.target.value
              })} data-id="element-27" />
              </div>
            </div>

            <div data-id="element-28">
              <label className="block text-sm text-brand-white/70 mb-1" data-id="element-29">
                Localidad / Barrio
              </label>
              <input required type="text" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
              ...formData,
              localidad: e.target.value
            })} data-id="element-30" />
            </div>

            <div className="grid md:grid-cols-2 gap-4" data-id="element-31">
              <div data-id="element-32">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-33">
                  Tipo de registro
                </label>
                <select className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                registro: e.target.value
              })} data-id="element-34">
                  <option data-id="element-35">Registro profesional</option>
                  <option data-id="element-36">Registro particular</option>
                  <option data-id="element-37">No tengo registro</option>
                </select>
              </div>
              <div data-id="element-38">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-39">
                  Modalidad
                </label>
                <select className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                modalidad: e.target.value
              })} data-id="element-40">
                  <option data-id="element-41">Turno — 12 horas</option>
                  <option data-id="element-42">A cargo — 24 horas</option>
                  <option data-id="element-43">Alquiler con opción a compra</option>
                </select>
              </div>
            </div>

            <div data-id="element-44">
              <label className="block text-sm text-brand-white/70 mb-2" data-id="element-45">
                ¿Trabajás actualmente en alguna app?
              </label>
              <div className="flex gap-4" data-id="element-46">
                {['Sí', 'No, quiero empezar'].map(opt => <label key={opt} className="flex items-center gap-2 text-brand-white cursor-pointer" data-id="element-47">
                    <input type="radio" name="trabaja" value={opt} className="accent-brand-gold" onChange={e => setFormData({
                  ...formData,
                  trabaja: e.target.value
                })} defaultChecked={opt === 'No, quiero empezar'} data-id="element-48" />
                    {opt}
                  </label>)}
              </div>
            </div>

            <button type="submit" className="w-full mt-6 py-4 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-49">
              QUIERO ALQUILAR
            </button>
          </form>
        </motion.div>
      </div>

      {/* Divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" data-id="element-50"></div>
    </section>;
}